import { render, staticRenderFns } from "./KoioteTankCanvas.vue?vue&type=template&id=4555ee4b&scoped=true"
import script from "./KoioteTankCanvas.vue?vue&type=script&lang=js"
export * from "./KoioteTankCanvas.vue?vue&type=script&lang=js"
import style0 from "./KoioteTankCanvas.vue?vue&type=style&index=0&id=4555ee4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555ee4b",
  null
  
)

export default component.exports